import { render, staticRenderFns } from "./CountryRankTable.vue?vue&type=template&id=6784e1d6&scoped=true&"
import script from "./CountryRankTable.vue?vue&type=script&lang=js&"
export * from "./CountryRankTable.vue?vue&type=script&lang=js&"
import style0 from "./CountryRankTable.vue?vue&type=style&index=0&id=6784e1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6784e1d6",
  null
  
)

export default component.exports